import ApplicationController from './application-controller.js'
import ky from 'lib/ky'

export default class extends ApplicationController {
  static targets = ['submitButton']
  connect () {
    this.invalidFields = []
    this.element.addEventListener('invalid', this.handleInvalid.bind(this), true)
    this.element.addEventListener('keyup', this.dismissError.bind(this), true)
    this.element.addEventListener('click', this.dismissError.bind(this), true)
  }

  async submit (event) {
    event.preventDefault()
    this.#lockSubmitButton()
    this.dispatch('submit-start')
    this.errorDismissed = false
    setTimeout(async () => {
      await this.#processSubmit()
      this.#unlockSubmitButton()
    }, 300)
  }

  async handleInvalid (event) {
    this.errorShown || this.dispatch('submit-finish')
    if (!this.errorDismissed) {
      // event.preventDefault()
      this.errorShown || this.dispatch('submit-error', { detail: { type: 'invalid', event } })
      this.errorShown = true
    }
  }

  async dismissError () {
    this.errorShown = false
    this.errorDismissed = true
    this.#cleanCustomValidity()
    this.form.reportValidity()
  }

  async dismissSuccess () {
    this.form.reset()
  }

  async #processSubmit () {
    if (!this.#validate()) return
    try {
      const response = await this.#post()
      const json = await response.json()
      this.dispatch('submit-success', { detail: { json, response } })
    } catch (error) {
      this.#processError(error)
    }
    this.dispatch('submit-finish')
  }

  async #processError (error) {
    const { response } = error
    const json = await error.response.json()
    this.dispatch('submit-error', { detail: { type: 'send', json, response, error } })
    Object.entries(json.errors).forEach(([fieldName, message]) => {
      const field = this.element.querySelector(`[name="${fieldName}"]`)
      if (field) {
        field.setCustomValidity(message)
        field.reportValidity()
        this.invalidFields.push(field)
      }
    })
  }

  #cleanCustomValidity () {
    this.invalidFields.forEach(field => {
      field.setCustomValidity('')
    })
    this.invalidFields = []
  }

  #validate () {
    return this.form.reportValidity()
  }

  async #post () {
    const data = Object.fromEntries(new FormData(this.form))
    delete data.authenticity_token
    // FIXME: inflection should be camel but this will require client side transformation of the field names
    return await ky.post(this.form.action, { headers: { 'Key-Inflection': 'snake' }, body: JSON.stringify(data) })
  }

  #lockSubmitButton () {
    this.submitButtonTarget.setAttribute('disabled', 'disabled')
    setTimeout(() => { // failsafe
      this.#unlockSubmitButton()
    }, 5000)
  }

  async #unlockSubmitButton () {
    this.submitButtonTarget.removeAttribute('disabled')
  }

  get form () {
    return this.element
  }
}
